import React, { useEffect } from 'react';
import { string, bool, func } from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { CtaSection } from '../common/CtaSection';
import { buildSamLink } from '../../utils/home-services-cta-utils';
import { SCHEDULE_A_MEASURE_CONTACT_NUMBER } from '../../utils/home-services-cta-constants';
import { dataModel } from './dataModel';

const ScheduleAMeasureCta = ({
  itemId, onClick, hideContactInfo, target, enableNewTab
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('schedule-a-measure.ready'); }, []);

  const { data } = useDataModel('product', {
    variables: {
      itemId,
    },
    ssr: true,
  });

  const { product: {
    identifiers: {
      specialOrderSku,
      storeSkuNumber
    } = {}
  } = {} } = data || {};

  if (!itemId) {
    return null;
  }

  return (
    <CtaSection
      buttonText="Schedule a Measure"
      contactNumber={SCHEDULE_A_MEASURE_CONTACT_NUMBER}
      buttonLink={buildSamLink(specialOrderSku || storeSkuNumber)}
      hideContactInfo={hideContactInfo}
      openContentInDrawer={!enableNewTab}
      onClick={onClick}
      target={target}
    />
  );
};

ScheduleAMeasureCta.displayName = 'ScheduleAMeasureCta';

ScheduleAMeasureCta.dataModel = dataModel;

ScheduleAMeasureCta.propTypes = {
  itemId: string.isRequired,
  onClick: func,
  hideContactInfo: bool,
  target: string,
  enableNewTab: bool
};

ScheduleAMeasureCta.defaultProps = {
  hideContactInfo: false,
  onClick: () => {},
  target: '_blank',
  enableNewTab: false
};

export { ScheduleAMeasureCta };